import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "./data";
import { scrollToId } from "./hooks";

export function Services() {
  return (
    <section id="services" className="bg-[#182330] text-[#eef4f8] py-24 md:py-32 border-b border-[#213042]" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-16 reveal">
          <span className="font-mono-code text-xs text-[#00c2a8] uppercase tracking-widest block mb-2">// SYSTEM SERVICES</span>
          <h2 className="font-mono-code text-[clamp(28px,3.8vw,48px)] font-bold uppercase text-white mb-4 leading-tight">
            Complete Sealant Packages
          </h2>
          <p className="text-sm text-[#a2b8cc] leading-relaxed">
            Engineered mastic applications for developers, main contractors and private property owners — with
            commercial and industrial sealing packages at the core of what we do.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.n}
              className="reveal group bg-[#111923] border border-[#213042] p-6 rounded hover:border-[#00c2a8]/60 transition-colors flex flex-col"
              style={{ transitionDelay: `${(i % 3) * 60}ms` }}
              data-testid={`service-card-${i + 1}`}
            >
              <span className="font-mono-code text-xs text-[#00c2a8] block mb-2">{s.n}. {s.tag}</span>
              <h3 className="font-mono-code text-base font-bold uppercase text-white mb-2 leading-snug">{s.title}</h3>
              <p className="text-xs text-[#7d96ac] leading-relaxed mb-5">{s.desc}</p>
              <button
                onClick={() => scrollToId("contact")}
                className="mt-auto inline-flex items-center gap-1.5 font-mono-code text-[11px] uppercase tracking-wider text-[#a2b8cc] group-hover:text-[#00c2a8] transition-colors"
                data-testid={`service-quote-btn-${i + 1}`}
              >
                Get A Quote <ArrowUpRight className="w-3.5 h-3.5" aria-hidden="true" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
